export const getCountry = event => {
  if (
    !event ||
    !event.location ||
    event.location.type !== "address" ||
    !event.location.addressComponents
  ) {
    return false;
  }
  const addressComponents = event.location.addressComponents;
  const country = addressComponents.find(component =>
    component.types.includes("country")
  );
  if (country) {
    return country.long_name.toLowerCase();
  }
  return false;
};

export const getLocality = event => {
  if (
    !event ||
    !event.location ||
    event.location.type !== "address" ||
    !event.location.addressComponents
  ) {
    return false;
  }
  const addressComponents = event.location.addressComponents;
  const locality = addressComponents.find(component =>
    component.types.includes("locality")
  );
  if (locality) {
    return locality.long_name.toLowerCase();
  }
  return false;
};



// WEBPACK FOOTER //
// ./utils/Location.js